import config from 'config';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { sendAmplitudeData } from 'util/amplitude';
const firebaseConfig = {
  apiKey: config.firebaseApiKey,
  authDomain: config.firebaseAuthDomain,
  projectId: config.firebaseProjectId,
  storageBucket: config.firebaseStorageBucket,
  messagingSenderId: config.firebaseSenderId,
  appId: config.firebaseAppId,
  measurementId: config.firebaseMeasurementId,
};
initializeApp(firebaseConfig);
const messaging = getMessaging();

export const requestForToken = async () => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_ID,
    });
    if (currentToken) {
      sendAmplitudeData('FCM token received', {
        token: currentToken,
      });
      return {
        token: currentToken,
      };
    } else {
      console.log('No token found');
    }
  } catch (err) {
    console.log('Error occurred', err);
    sendAmplitudeData('FCM token error', {
      error: err,
    });
  }
};

onMessage(messaging, (payload) => {
  const audioUrl = payload && payload.data && payload.data.notificationSoundUrl;
  try {
    let audio = new Audio(audioUrl);
    audio.play();
    sendAmplitudeData('Notification Sound played', {
      payload: payload,
    });
  } catch (err) {
    sendAmplitudeData('Notification error', {
      error: err,
    });
  }
});
